const KEY = 'portfolio-nav-scroll';
const MAX_AGE_MS = 5000;
const MAX_RESTORE_MS = 4000;

export function savePortfolioNavScroll() {
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ y: window.scrollY, savedAt: Date.now() })
    );
  } catch {
    // ignore
  }
}

export function restorePortfolioNavScroll() {
  let raw: string | null = null;
  try {
    raw = sessionStorage.getItem(KEY);
  } catch {
    // ignore
  }
  if (!raw) return;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }

  let parsed: { y: number; savedAt: number } | null = null;
  try {
    parsed = JSON.parse(raw);
  } catch {
    // ignore
  }
  if (!parsed || typeof parsed.y !== 'number') return;
  if (Date.now() - parsed.savedAt > MAX_AGE_MS) return;

  const targetY = parsed.y;
  const startedAt = performance.now();

  const attempt = () => {
    const maxScrollable =
      document.documentElement.scrollHeight - window.innerHeight;
    if (maxScrollable >= targetY) {
      window.scrollTo({ top: targetY, behavior: 'auto' });
      return;
    }
    if (performance.now() - startedAt < MAX_RESTORE_MS) {
      requestAnimationFrame(attempt);
    } else {
      window.scrollTo({ top: Math.min(targetY, maxScrollable), behavior: 'auto' });
    }
  };
  requestAnimationFrame(attempt);
}
